var map = {
	"./Background.jpg": 252,
	"./Big Jet Plane 2019.mp3": 156,
	"./Days Run Out 2016.mp3": 104,
	"./Disappear 2024.mp3": 450,
	"./Never Said 2017.mp3": 816,
	"./Nouvel An 2025.wav": 50,
	"./Take me 2015.mp3": 760,
	"./World is One 2020.mp3": 577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;